<template>
  <!-- TODO: 只显示当前委托单下的数据 -->
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="样品列表" name="first">
      <pt-gene-lab-order ref="orderTable" :needRefreshOrder="needRefreshOrder" :hideTitle="true" :billId="billId" @selection-change="getSelectedOrder" :isDialog="true" :canSelect="canSelect" :noAllExport="true" @getOrderExportExcel="getOrderExportExcel" :exportLoading="exportLoading" :comePage="comePage">
        <div slot="otherBtn" v-if="!hasComplete">
          <el-button type="primary" @click="handleRemove" :loading="removeLoading">移除</el-button>
          <el-button type="primary" @click="handleAdd">新增</el-button>
          <!-- 委托单待回传之后才显示 -->
          <el-button type="primary" @click="handleDistribute" :loading="distributeLoading">分派任务</el-button>
        </div>

      </pt-gene-lab-order>
    </el-tab-pane>
    <el-tab-pane label="检测项目" name="second">
      <el-button style="margin:10px;" type="primary" @click="handleDistribute" :loading="distributeLoading">分派任务
      </el-button>
      <base-table :table-data="labExamItemList" :columns="tableLabels" selectType="checkbox" @selection-change="handleSelectionChange">
			<template slot="attachments" slot-scope="scope">
				<div v-for="(item,i) in scope.row.attachments" :key="i">
					<a :class="$style['item-line']" :href="$privateResourcesUrl+item.ossUrl.replace(/\+/g, '%2B')" target="_blank" v-if="item&&item.ossUrl">{{item.name}}</a>
				</div>
      </template>
        <template slot="operate" slot-scope="scope">
          <el-button type="text" v-if="!scope.row.excelCreate" @click="goProductDetail(scope.row.id)">详情</el-button>
        </template>
      </base-table>
    </el-tab-pane>
    <el-tab-pane label="任务单" name="third">
      <pt-production-task-list :hideTitle="true" :hasComplete="hasComplete" :billId="billId"></pt-production-task-list>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import ptGeneLabOrder from 'cps/lab-order/pt-gene-lab-order'
import ptLabProduct from 'cps/lab-product/pt-lab-product'
import ptProductionTaskList from 'cps/production-task/pt-production-task-list'
import { productTableLabels } from 'cps/trust-deed/pt-trust-deed-detail/options.js'
export default {
  components: {
    ptGeneLabOrder,
    ptLabProduct,
    ptProductionTaskList
  },
  props: {
    isComplete: {
      type: Boolean,
      default: false
    },
    billId: {
      type: String,
      default: ''
    },
    labExamItemList: {
      type: Array,
      default: () => []
    },
    billCode: {
      type: String,
      default: ''
    },
    comePage: String,
    needRefreshOrder: Boolean,//是否需要刷新样品列表，当委托单已回传的时候，需要刷新一次样品列表
    canSelect: Boolean// 是否可直接选择（用于委托单详情页面的样本导出，选择之后无需传出直接在列表页面做导出处理）
  },
  data () {
    return {
      tableLabels: productTableLabels,
      activeName: 'first',
      selectOrder: [],
      selectProduct: [],
      removeLoading: false,
      distributeLoading: false,
			exportLoading: false,
      privateResourcesUrl: this.$privateResourcesUrl,
      uploadApi: this.$uploadApi,
      picture_params: {
        resourceName: 'literature',
        objectId: this.value?.id || 0
      }
    }
  },
  computed: {
    hasComplete () {
      return this.isComplete
    }
  },
  methods: {
    getOrderExportExcel (params) {
      let data = {
        ...params
      }
      this.exportLoading = true
      this.$store.dispatch('getOrderExportExcel', data).then(res => {
        this.$message.success('样本导出成功')
        this.exportLoading = false
      }).catch(err => {
        this.$message.success(err || '样本导出失败')
        this.exportLoading = false
      })
    },
    reload () {
      this.$refs.orderTable.reload()
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    handleSelectionChange (rows) {
      this.selectProduct = rows
    },
    goProductDetail (id) {
      this.$router.push(`/lab-product-detail/${id}`)
    },
    getSelectedOrder (data) {
      this.selectOrder = data
      this.$emit('select-order-change', data)
    },
    handleRemove () {
      if (!this.selectOrder.length) {
        this.$message.warning('请先勾选样品')
        return
      }
      this.$confirm(`您勾选了${this.selectOrder.length}条样品信息，是否确认从该委托单中移除?`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.removeLoading = true
        let data = {
          billId: this.billId,
          orderIds: this.selectOrder.map(e => e.id)
        }
        this.$store.dispatch('removeOrders', data).then(res => {
          this.$message.success('操作成功')
          this.$emit('reload')
          this.$refs.orderTable.reload()
        }).catch(err => {
          this.$message.warning(err || '操作失败')
        }).finally(() => {
          this.removeLoading = false
        })
      })
    },
    handleAdd () {
      this.$router.push(`/batch-add-lab-order?billId=${this.billId}&billCode=${this.billCode || '--'}`)
    },
    handleDistribute () {
      if (this.activeName === 'first' && !this.selectOrder.length) {
        this.$message.warning('请先勾选样品')
        return
      }
      if (this.activeName === 'second' && !this.selectProduct.length) {
        this.$message.warning('请先勾选检测项目')
        return
      }
      this.distributeLoading = true
      let data = {
        billId: this.billId
      }
      if (this.activeName === 'first') {
        data.orderIds = this.selectOrder.map(e => e.id)
      } else {
        data.labExamItemIds = this.selectProduct.map(e => e.id)
      }
      this.$store.dispatch('assginPre', data).then(data => {
        this.$router.push(`/distribute-task/${data.billId}`)
      }).catch(err => {
        this.$message.warning(err || '操作失败')
      }).finally(() => {
        this.distributeLoading = false
      })
    }
  }
}
</script>
<style module lang="less">

.item-line {
      // line-height: 30px;
      color: #409eff;
      text-decoration: underline;
    }

</style>